<template>
  <section class="webinar-calendar" >
    <v-container>
      <events-filter-wrapper v-slot="p" class="mb-5">
        <rawlplug-events-calendar
          :events-filter-fn="val => eventFilterFn(val, p)"
          @gotEvents="val => onEventReceived(val, p)"
          @gotArchives="p.archivesReceived"
          @typeChange="val => onTypeChange(val, p)"
          @created="$emit('eventsCalendarCreated')"
          @eventChange="ev => $emit('eventChange', ev)">
          <p v-html="$t('webinars.calendar_description')"></p>

          <template #beforeCalendar>
            <div class="v-row pb-4 filters">
              <div class="v-col-12 v-col-sm-3">
                <rwl-label>{{ $t('webinars.trainingLanguage') }}</rwl-label>
                <rwl-select :options="p.trainingLanguages"
                            :value="p.selectedLanguage"
                            @input="(val) => p.selectLanguage(val)"></rwl-select>
              </div>
              <div class="v-col-12 v-col-sm-3">
                <rwl-label>{{ $t('webinars.trainingGroup') }}</rwl-label>
                <rwl-select :options="p.trainingGroups"
                            :value="p.selectedTrainingGroup"
                            @input="(val) => p.selectTrainingGroup(val)"></rwl-select>
              </div>
            </div>
          </template>
        </rawlplug-events-calendar>
      </events-filter-wrapper>
      <external-events></external-events>
    </v-container>
  </section>
</template>

<script>
  import RawlplugEventsCalendar, { EventsFilterWrapper } from "@rawlplug/rawlplug-events-calendar"
  import { RwlSelect, RwlLabel } from "@rawlplug/rawlplug-design-components-library"
  import { VContainer } from "./ui/index";
  import ExternalEvents from "./external-events/ExternalEvents";

  export default {
    name: "WebinarCalendar",
    components: {
      RawlplugEventsCalendar,
      VContainer,
      'events-filter-wrapper' : EventsFilterWrapper,
      RwlSelect,
      RwlLabel,
      ExternalEvents,
    },
    methods: {
        onTypeChange(val, p ) {
          p.typeChange(val);
        },
        onEventReceived(val, p) {
          console.log({this: this})
          if(this.$calendarConfig.calendarForm.availableLanguages !== "ALL") {
            val = val.filter(item => {
              let languageOfTraining = item.eventParts[0].languageOfTraining;
              let included = this.$calendarConfig.calendarForm.availableLanguages.split(',').includes(languageOfTraining);
                console.log({ included, languageOfTraining })
              if(included) {
                return true;
              }
              return false;
            })
          }

          p.eventsReceived(val);
        },
        eventFilterFn(val, p) {
          if(this.$calendarConfig.calendarForm.availableLanguages !== "ALL") {
            val = val.filter(item => {
              let languageOfTraining = item.eventParts[0].languageOfTraining;
              if(this.$calendarConfig.calendarForm.availableLanguages.split(',').includes(languageOfTraining)) {
                return true;
              }
              return false;
            })
          }
          return p.eventFilterFn(val)
        }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@rawlplug/rawlplug-design-style-tokens/dist/scss/all";

  .webinar-calendar {
    padding: $section-padding;
    background: url("#{$assetsPath}images/calendar_background.jpg");
    background-size: 1200px;

    ::v-deep {
      .event__container {
        z-index: 85;
      }

      @media (max-width: 767px) {
        .event__container {
          z-index: 101;
        }
      }

      ul li {
        &:before {
          content: none;
        }

        a {
          display: block;
          border-bottom: none;
        }
      }
    }
  }

  .filters ::v-deep li {
    &::before {
      content: none;
    }
  }

  ::v-deep textarea[name=message] {
    min-height: auto;
    height: 40px;
  }
</style>
